import { render, staticRenderFns } from "./mb-sort-order-input.vue?vue&type=template&id=5be74ab0&"
import script from "./mb-sort-order-input.vue?vue&type=script&lang=ts&"
export * from "./mb-sort-order-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports